module.exports = __webpack_public_path__ + "img/project-4.0498fa54.jpg";